// extracted by mini-css-extract-plugin
export default {"bubble":"MessageBubble_bubble__Y3dC0","user":"MessageBubble_user__RxkZF","bot":"MessageBubble_bot__oQEIg"};